/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enumeration of implemented MFA factor types.
 *
 * Future factor types to implement:
 * - BACKUP_CODES = "backup_codes"
 */
export enum FactorType {
    PUSH_NOTIFICATION = 'push_notification',
    PASSWORD = 'password',
    WHATSAPP_OTP = 'whatsapp_otp',
    SMS_OTP = 'sms_otp',
    EMAIL_OTP = 'email_otp',
    TOTP = 'totp',
    WEBAUTHN = 'webauthn',
    RECOVERY_QUESTIONS = 'recovery_questions',
    DEVICE_KEY = 'device_key',
    EXTERNAL_SSO = 'external_sso',
}
